import {
    FETCH_MACHINE_TYPES_FAILURE,
    FETCH_MACHINE_TYPES_SUCCESS,
    FETCH_CUSTOMER_TYPES_SUCCESS,
    FETCH_CUSTOMER_TYPES_FAILURE,
    FETCH_FACTORY_TYPES_SUCCESS,
    FETCH_FACTORY_TYPES_FAILURE,
    FETCH_SERIALNUMBER_TYPES_SUCCESS,
    FETCH_SERIALNUMBER_TYPES_FAILURE
  } from "../_constants";

  const initialState = {
    loading: false,
    selectMachineTypes:"",
    selectCustomerTypes:"",
    selectFactoryTypes:"",
    selectSerialNumberTypes:"",
    error:"",
    success:false
  };

  export const scopedMenuReducer = (state = initialState, action) => {
    switch (action.type) {
    case FETCH_MACHINE_TYPES_SUCCESS:
      return{
        ...state,
        loading: false,
        selectMachineTypes: action.payload,
        error:""
      };
    case FETCH_MACHINE_TYPES_FAILURE:
      return{
        ...state,
        loading: false,
        selectMachineTypes:"",
        error: action.payload
      };
    case FETCH_CUSTOMER_TYPES_SUCCESS:
      return{
        ...state,
        loading: false,
        selectCustomerTypes: action.payload,
        error:""
      };
    case FETCH_CUSTOMER_TYPES_FAILURE:
      return{
        ...state,
        loading: false,
        selectCustomerTypes:"",
        error: action.payload
      };
    case FETCH_FACTORY_TYPES_SUCCESS:
      return{
        ...state,
        loading: false,
        selectFactoryTypes: action.payload,
        error:""
      };
    case FETCH_FACTORY_TYPES_FAILURE:
      return{
        ...state,
        loading: false,
        selectFactoryTypes:"",
        error: action.payload
      };
      case FETCH_SERIALNUMBER_TYPES_SUCCESS:
      return{
        ...state,
        loading: false,
        selectSerialNumberTypes: action.payload,
        error:""
      };
    case FETCH_SERIALNUMBER_TYPES_FAILURE:
      return{
        ...state,
        loading: false,
        selectSerialNumberTypes:"",
        error: action.payload
      };
    default:
      return state;
    }
};